import { Controller, useFormContext } from "react-hook-form";
import { useTranslation } from "react-i18next";

import { ErrorMessage, InputRadio, Text } from "@pentabd/ui";

import { InputDateControllerRow, InputTextRow } from "@components";

import { useLanguage } from "@hooks/useLanguage";
import { useMasterData } from "@hooks/useMasterData";

import { getConvertedMasterData } from "@helpers/masterDataConvert";

import { MASTER_DATA } from "@constants/master-data";

import {
  CHILDREN,
  ChildrenFormDataType,
} from "@validations/HRM/employee/familyInfoValidation";

const { GENDER } = MASTER_DATA;

export const ChildForm = ({
  id,
  isProfileDisabled,
}: {
  id: number;
  isProfileDisabled: boolean;
}) => {
  const { language } = useLanguage();
  const { t } = useTranslation();

  //This data will use for radio
  const { data: gender } = useMasterData(GENDER);

  const {
    register,
    control,
    formState: { errors },
  } = useFormContext<ChildrenFormDataType>();

  return (
    <div className="d-flex flex-column gap-8">
      <InputTextRow
        register={{ ...register(CHILDREN.CHILDREN_NAME) }}
        label="EMPLOYEE.FAMILY_INFO.FORM.CHILDREN_INFO.CHILD_NAME"
        error={errors as any}
        required
        disabled={isProfileDisabled}
      />

      <div className="row">
        <div className="col-md-12 col-lg-3">
          <Text weight="semibold" color="title" size="sm">
            {t("EMPLOYEE.FAMILY_INFO.FORM.CHILDREN_INFO.GENDER.LABEL")}
          </Text>
          <span className="text-danger">&#42;</span>
        </div>
        <div className="col-md-12 col-lg-7">
          <div className="d-flex gap-8">
            <Controller
              control={control}
              name={CHILDREN.CHILDREN_GENDER}
              render={() => {
                return (
                  <div className="d-flex gap-8 flex-wrap">
                    {getConvertedMasterData(gender, language, true).map(
                      (genderOption, index) => (
                        <InputRadio
                          key={index}
                          {...register(CHILDREN.CHILDREN_GENDER)}
                          name={CHILDREN.CHILDREN_GENDER}
                          id={`${genderOption.id}-${id}`}
                          title={genderOption.label}
                          value={genderOption.value}
                          disabled={isProfileDisabled}
                        />
                      ),
                    )}
                  </div>
                );
              }}
            />
          </div>
          <ErrorMessage
            errors={errors as any}
            name={CHILDREN.CHILDREN_GENDER}
          />
        </div>
      </div>
      <InputDateControllerRow
        control={control}
        register={{ ...register(CHILDREN.CHILDREN_DOB) }}
        errors={errors as any}
        name={CHILDREN.CHILDREN_DOB}
        label="EMPLOYEE.FAMILY_INFO.FORM.CHILDREN_INFO.DATE_OF_BIRTH"
        required
        disabled={isProfileDisabled}
      />
    </div>
  );
};
